import PropTypes from 'prop-types'
import { View } from './View'

/**
 * Appkit4 Radioコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/radio?background=transparent&variation=selected&modifier=label-list&version=react" target="_blank">こちら</a>
 */
export const Radio = ({ ...props }) => {
    return <View {...props} />
}

Radio.propTypes = {
    /**
     * ラジオのvalueとラベル<font color="red">*</font>
     */
    itemList: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            label: PropTypes.string
        })
    ).isRequired,
    /**
     * name<font color="red">*</font>
     */
    name: PropTypes.string.isRequired,
    /**
     * デフォルト値
     */
    defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
     * 選択している値
     */
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
     * イベントハンドラー<br>
     *  (value: number | string, event: React.SyntheticEvent) => void
     */
    onChange: PropTypes.func,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Radio.defaultProps = {
    itemList: [],
    name: ''
}
